import React from 'react';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { Actor_ } from '../../../components/actor/Actor_';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { SkeletonRegistryDraftWordTask } from './SkeletonsWordTask';
export class SkeletonsKnowAWord extends SkeletonRegistryCategory {
    label = 'KnowAWord';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_wordTask = new SkeletonRegistryDraftWordTask(this);
    draftKnowAWordStructure_base = () => new SkeletonRegistryItem({
        label: 'Simple Structure',
        jsx: ({ question }) => {
            if (!question)
                return null;
            const question_ = question;
            return (React.createElement(Aspect_, { aspect: question_.inner },
                React.createElement(Actor_, { actor: question_.questionPart }),
                React.createElement(Actor_, { actor: question_.wordTask })));
        },
    });
    nearestWordingString = () => new SkeletonRegistryItem({
        label: 'Nearest Wording To Input',
        jsx: ({ wordTask }) => {
            if (!wordTask)
                return null;
            return React.createElement("span", null, wordTask.wordTaskNearest.nearestWording && wordTask.wordTaskNearest.nearestWording.wordingString);
        },
    });
}
